<div class="tooltip-content">
    <div class="line"></div>
    <p><u style="font-weight: bold;"><a href="https://textinspector.com/subscription-details/" style="color: #2A3654;" target="_blank" rel="noopener noreferrer">SUBSCRIBE NOW</a></u> to see your text’s real CEFR Level. This is a sample.</p>
  </div>
